import React from 'react';
import styles from './Root.module.scss';
import cn from 'classnames';

const Root = ({ children, classname = '', ...props }) => {
  return (
    <div
      className={cn(styles.root, classname)}
      {...props}
    >
      {children}
    </div>
  );
};

export default Root;
